import { imagePathFromImageType } from "@fwa/src/services/imageService";

import { type ImageType, type RotateType } from "@fwa/src/types";

interface UploadedImage {
  url: string;
  title?: string;
  height?: string;
  width?: string;
}

export const GalleryThumbnail = ({
  image,
  rotation,
}: {
  image: ImageType | UploadedImage;
  rotation?: RotateType;
  hasBorder?: boolean;
}) => (
  <div
    style={{
      padding: "var(--spacing-xxs, 0.5rem)",
      backgroundColor: "var(--clr-background-mid, #e6e6e6)",
      boxShadow: "var(--shadow-s, 0px 0px 2px 1px #c6c6c6)",
    }}
  >
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingBottom: "100%",
      }}
    >
      {image && (
        <img
          alt={image?.title || ""}
          src={
            "filePath" in image && image.filePath
              ? imagePathFromImageType(image)
              : image.url
          }
          height={image?.height}
          width={image?.width}
          loading="lazy"
          style={{
            position: "absolute",
            width: "auto",
            height: "auto",
            maxHeight: "100%",
            maxWidth: "100%",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: "auto",
            transition: "transform 1s ease",
            transform: `rotate(${rotation || 0}deg)`,
          }}
        />
      )}
    </div>
  </div>
);

export default GalleryThumbnail;
